import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import * as Icon from '../../Imports/Icons';
import Button from '@material-ui/core/Button';
import Axios from '../../Imports/Axios';
import { SaadDate } from '../../Imports/SaadDate';
let SaadDateObj = null;
// eslint-disable-next-line
SaadDateObj = SaadDate.then(obj => {
  SaadDateObj = new obj();
});
const useStyles = theme => ({
  toolbar: {
    minHeight: 40,
    background: 'rgba(56, 32, 110, 0.9)'
  }
});
class Default extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tasks: [],
      showData: false
    };
  }
  async componentDidMount() {
    this.props.socket.on('tasksInDashboard', async () => {
      console.log('123')
      this.getData('noBackdrop');
    });
    await this.getData('noBackdrop');
  }
  async getData(backdropOption) {
    if (backdropOption === 'backdrop') {
      this.props.pageBackDrop(true);
    }
    let requestOptions = {
      url: 'dashboards/index'
    };
    try {
      const response = await Axios(requestOptions);
      if (response.data.status === 1000) {
        this.setState({
          tasks: response.data.data.tasks,
          showData: true
        });
        this.props.pageBackDrop(false);
      } else if (response.data.status !== 300) {
        this.props.pageSnackMessage({
          alertSeverity: 'error',
          alertMessage: response.data.message,
          openSnackbar: true
        });
        this.setState({
          showData: false
        });
        this.props.pageBackDrop(false);
      } else {
        this.setState({
          showData: false
        });
        this.props.pageBackDrop(false);
      }
    } catch (error) {
      console.log(error);
      this.props.pageSnackMessage({
        alertSeverity: 'error',
        alertMessage: 'عدم دسترسی به سرور',
        openSnackbar: true
      });
      this.setState({
        showData: false
      });
      this.props.pageBackDrop(false);
    }
  }
  pageBackDrop(option) {
    this.setState({
      openBackdrop: option
    });
  }
  pageSnackMessage(option) {
    this.setState({
      alertSeverity: option.alertSeverity,
      alertMessage: option.alertMessage,
      openSnackbar: option.openSnackbar
    });
  }
  render() {
    const {
      tasks,
      showData
    } = this.state;
    const getNameOfUser = user => {
      if (user) {
        return `${user.published.name} ${user.published.family}`;
      } else {
        return 'نامشخص!';
      }
    };
    const getStatus = status => {
      let result = null;
      switch (status) {
        case '0':
          result = <div className='color-red'>انجام نشده</div>;
          break;
        case '1':
          result = <div className='color-orange'>انجام شده در انتظار تایید</div>;
          break;
        case '2':
          result = <div className='color-green'><Icon.Save /></div>;
          break;
        default:
          result = null;
      }
      return result;
    };
    return <div dir="rtl" className="panel-wrapper">
           <div className="actions">
      
       <Tooltip title="بارگیری مجدد" placement="right" classes={{
          tooltip: "toolTip",
          arrow: "toolTipArrow"
        }} arrow>
          <Button id="reloadDashboard" className="action-button" onClick={() => {
            this.setState({
              tasks: [],
              showData: false
            }, () => {
              this.getData('backdrop');
            });
          }}>
            <Icon.Refresh className="action-icon" />
          </Button>
       </Tooltip>

       <Tooltip title="راهنما" placement="right" classes={{
          tooltip: "toolTip",
          arrow: "toolTipArrow"
        }} arrow>
          <Button className="action-button help">
            <Icon.Help className="action-icon" />
          </Button>
       </Tooltip>

        </div>
            {showData ? <Grid container spacing={0} margin={10}>
              <Grid className="box" item xs={12}>
                  <div className="content">
                    <div className="title">وظایف امروز</div>
                    {tasks.length > 0 ? <TableContainer component={Paper}>
                      <Table className="tb-view">
                        <TableHead>
                          <TableRow>
                            <TableCell align="right">#</TableCell>
                            <TableCell align="right">عنوان</TableCell>
                            <TableCell align="right">پرونده</TableCell>
                            <TableCell align="right">مجری</TableCell>
                            <TableCell align="right">پیگیری</TableCell>
                            <TableCell align="right">وضعیت</TableCell>
                            <TableCell align="right"></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {tasks.map((item, i) => {
                    return <TableRow key={i}>
                                  <TableCell align="right" component="th" scope="row">
                                    {i + 1}
                                  </TableCell>
                                  <TableCell align="right" component="th" scope="row">
                                    {item.published.title}
                                  </TableCell>
                                  <TableCell align="right" component="th" scope="row">
                                    {item.published.dossier ? item.published.dossier.published.title : '-'}
                                  </TableCell>
                                  <TableCell align="right" component="th" scope="row">
                                    {getNameOfUser(item.published.assignedTo)}
                                  </TableCell>
                                  <TableCell align="right" component="th" scope="row">
                                    {getNameOfUser(item.published.admin)}
                                  </TableCell>
                                  <TableCell align="right" component="th" scope="row">
                                    {getStatus(item.published.status)}
                                  </TableCell>
                                  <TableCell align="left" component="th" scope="row">
                                  <Button data-document={item._id} data-id={`Tasks_view_${item._id}`} data-title="مشاهده وظیفه" data-icon="Tasks" data-controller="Tasks" data-action="view" className="tb-btn" type="button" onClick={this.props.openTab.bind(this)}>
                                      <Icon.View />
                                    </Button>
                                  </TableCell>
                                </TableRow>;
                  })}

                        </TableBody>
                      </Table>
                    </TableContainer> : <div className='happy'>
                     <Icon.Happy />
                     فعلا که خبری نیست!
                 </div>}
                      


                  </div>
                        
              </Grid>

              
            </Grid> : <></>}
           

      </div>;
  }
}
export default withStyles(useStyles)(Default);